<div [ngClass]="['signin-overlay', visible ? 'show' : '']">
    <div class="signin-container" *ngIf="!showLearnMore; else learnMore">
        <div>
            <mat-icon
            data-cy="login-window-x-icon"
                svgIcon="cancel-close"
                style="cursor: pointer; color: white"
                (click)="closeOverlay()"
            ></mat-icon>
        </div>
        <div class="title-container">
            <div data-cy="login-window-title" class="title-large bold">
                {{ "dlg.signin.title" | translate }}
            </div>
            <div data-cy="login-window-info-text" class="text-small light">
                {{ "dlg.signin.learn" | translate }}
                <span
                data-cy="login-window-learn-more-button"
                    class="text-small bold"
                    style="cursor: pointer"
                    (click)="onShowLearnMore()"
                    >{{ "dlg.signin.learnmore.title" | translate }}</span
                >
            </div>
        </div>
        <div>
            <div *ngIf="loading" style="justify-content: center; display: flex">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <div *ngIf="!loading" class="role-btn-container">
                <div
                data-cy="login-window-role-container"
                    class="role-container"
                    *ngFor="let roleType of roleTypeArray"
                    (click)="onSelectedRole(roleType)"
                >
                    <mat-icon
                    data-cy="login-window-role-icon"
                        svgIcon="user-profile"
                        *ngIf="isIconLoaded('user-profile'); else loading"
                        style="width: 48px; height: 48px"
                    ></mat-icon>
                    <mat-progress-spinner
                        #loading
                        diameter="40"
                        value="100"
                        mode="indeterminate"
                        *ngIf="!isIconLoaded('user-profile')"
                    ></mat-progress-spinner>
                    <div data-cy="login-window-role-name" class="subtitle-smaller light text-style">
                        {{ roleType.role }}
                    </div>
                </div>
                <div class="empty-box"></div>
            </div>
        </div>
    </div>
    <ng-template #learnMore class="signin-container">
        <div class="signin-container learn-more">
            <div class="learn-more-contents">
                <div>
                    <mat-icon
                    data-cy="learn-more-window-x-icon"
                        svgIcon="cancel-close"
                        style="cursor: pointer; color: white"
                        (click)="closeLearnMore()"
                    ></mat-icon>
                </div>
                <div data-cy="learn-more-window-title" class="subtitle bold">
                    {{ "dlg.signin.learnmore.title" | translate }}
                </div>
                <div data-cy="learn-more-window-info-text" class="text detail">
                    {{ "dlg.signin.learnmore.description" | translate }}
                </div>
            </div>
            <div data-cy="learn-more-window-back-button" class="go-back-btn caption" (click)="onShowLearnMore()">
                {{ "dlg.signin.cancel" | translate }}
            </div>
        </div>
    </ng-template>
</div>
